var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkingPointsOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19C2 17.4999 2.61298 16.0613 3.7041 15.0005C4.79522 13.9398 6.2751 13.3439 7.81818 13.3439C9.36125 13.3439 10.8411 13.9398 11.9323 15.0005C13.0234 16.0613 13.6364 17.4999 13.6364 19H2ZM7.81818 12.6369C5.40727 12.6369 3.45454 10.7385 3.45454 8.3948C3.45454 6.05105 5.40727 4.15271 7.81818 4.15271C10.2291 4.15271 12.1818 6.05105 12.1818 8.3948C12.1818 10.7385 10.2291 12.6369 7.81818 12.6369ZM14.5425 5.69683C14.9058 6.55243 15.0921 7.4692 15.0909 8.3948C15.0921 9.3204 14.9058 10.2372 14.5425 11.0928L13.3229 10.2302C13.531 9.63945 13.6369 9.01924 13.6364 8.3948C13.6372 7.7704 13.5315 7.15019 13.3236 6.55939L14.5425 5.69683V5.69683ZM16.944 4C17.6409 5.36583 18.0023 6.87019 18 8.3948C18 9.97356 17.6196 11.4661 16.944 12.7896L15.7476 11.944C16.2751 10.8311 16.5473 9.6201 16.5454 8.3948C16.5454 7.12783 16.2596 5.9252 15.7476 4.84559L16.944 4V4Z",
    fill: "#333333"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.725953,
    y1: 1.31226,
    x2: 18.726,
    y2: 20.3123,
    stroke: "#D6451E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkingPointsOff);
export default __webpack_public_path__ + "static/media/talking-points-off.08cb59ea98dc56c089ca0950907b4a82.svg";
export { ForwardRef as ReactComponent };